import styled from "styled-components";

export const FormPageBody = styled.div`
  padding: 16px;
`;